export const RQ_EXCEL_UPLOAD = {
  url: 'api/product/upload/excel',
  method: 'POST',
  auth: true,
};
